import { connect } from 'react-redux';

import Header from './PaymentDetails';
import type { RootState } from 'services/store/types';

const mapStateToProps = (state: RootState) => ({
  user: state.user,
  config: state.config,
});

export default connect(mapStateToProps)(Header);
